var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{class:_vm.classBlock,attrs:{"outlined":"","value":_vm.saldo,"label":_vm.model.title,"error-messages":_vm.error,"disabled":_vm.disabled,"hide-details":_vm.config.hideDetails || false,"readonly":"","dense":_vm.config.dense || false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }